import { render, staticRenderFns } from "./ExtActTaskNotificationModal.vue?vue&type=template&id=57bf6e8a&scoped=true&"
import script from "./ExtActTaskNotificationModal.vue?vue&type=script&lang=js&"
export * from "./ExtActTaskNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bf6e8a",
  null
  
)

export default component.exports